import React from 'react'
import Loader from 'react-loader-spinner'
import styles from './Forms.module.sass'
import { useWeb3App } from "../../../core/appContext";
import { defaultScan } from "../../../config";
import {useLocation} from "react-router-dom";
import {humanCnr} from "../../../core/helpers";


export const BtnLoader = ({ step, target }) => {
    if (step.name !== target.name || step.status !== target.status) {
        return <></>
    }

    return (
        <div className={styles.loader_wrap}>
            <Loader
                type="TailSpin"
                color="#08A486"
                height={35}
                width={35}
            />
        </div>
    )
}

export function Stake({ balances }) {
    const ghApp = useWeb3App()
    const location = useLocation()
    const referrer = React.useMemo(() => {
        const query = new URLSearchParams(location.search);
        const reff = query.get('reff')
        if (!reff) return undefined
        if (!ghApp.web3.utils.isAddress(reff)) return undefined
        return reff
    }, [ghApp, location])
    const [amount, setAmount] = React.useState('')
    const [approveAmount, setApproveAmount] = React.useState('0')
    const [isApprove, setApprove] = React.useState(false)
    const [step, setStep] = React.useState({ name: 'approve', status: 'start' })
    const [tx, setTx] = React.useState("")
    const [err, setErr] = React.useState()
    React.useEffect(() => {
        async function getAllowance() {
            const allowance = await ghApp.allowanceCnr(ghApp.account)
            // console.log('%cStake.js line:46 allowance', 'color: #007acc;', allowance);
            setApproveAmount((parseInt(allowance)/1e18).toString())
        }
        getAllowance()
    }, [ghApp, isApprove, setApproveAmount])
    React.useEffect(() => {
        if (approveAmount !== '0' && amount < approveAmount) {
            setApprove(true)
        }
        // console.log('%cStake.js line:55 amount', 'color: #007acc;', approveAmount);
    }, [isApprove, approveAmount, amount])
    const handleApprove = () => {
        setErr(null)

        ghApp.approveStakeCnr(amount).catch(e => {
            setStep({ name: 'approve', status: 'error', message: `Transaction failed: ${e}` })
        })
        ghApp.on('approve:send', () => {
            setStep({ name: 'approve', status: 'pending' })
        })
        ghApp.on('approve:success', () => {
            setApproveAmount(amount)
            setApprove(true)
            setStep({ name: 'approve', status: 'done' })
        })
        ghApp.on('approve:error', (e) => {
            setApprove(false)
            setErr(e)
            setStep({ name: 'approve', status: 'error' })
        })
    }
    const handleStake = () => {
        setErr(null)

        ghApp.stakeCnr(amount, referrer).catch(err => {
            setStep({ name: 'stake', status: 'error', message: `Transaction failed: ${err}` })
        })
        ghApp.on('stake:send', _tx => {
            setTx(_tx)
            setStep({ name: 'stake', status: 'pending' })
        })
        ghApp.on('stake:error', err => {
            setErr(err.message)
            setStep({ name: 'stake', status: 'error' })
        })
        ghApp.on('stake:receipt', _tx => {
            setTx(_tx)
            setStep({ name: 'stake', status: 'done' })
            setAmount('')
            setApproveAmount(Number(approveAmount) - Number(amount))
            setApprove(false)
            ghApp.emit('tx:success')
        })
    }

    return (
        <div className={styles.form}>
            <div className={styles.wrap}>
                <div className={styles.body}>
                    <div className={styles.title}>Stake</div>
                    <div className={styles.title_desc}>Wallet Balance</div>
                    <div className={styles.clickable}>
                        <span
                            className={styles.amount}
                            onClick={() => setAmount(balances?.balanceCNR)}
                        >
                            {balances?.balanceCNR}
                        </span>
                        <span className={styles.amount_cur}> CNR</span>
                    </div>
                    <input
                        className={styles.input}
                        type="number"
                        placeholder="Amount to stake"
                        value={amount}
                        onChange={e => setAmount(e.target.value)}
                    />
                    {err && (<p className={styles.tx_desc}>{err}</p>)}
                    {tx && (<div>
                        <a href={`${defaultScan}/tx/${tx}`} className={styles.link} target="_blank" rel="noreferrer">
                            Transaction link
                        </a>
                    </div>)}
                </div>
                <div className={styles.footer}>
                    <button
                        onClick={handleApprove}
                        disabled={isApprove && (Number(amount) < Number(approveAmount) ||  (step.name === 'approve' && step.status === 'pending'))}
                        className={styles.lft_btn}
                    >
                        <BtnLoader step={step} target={{ name: 'approve', status: 'pending' }} />
                        <span>Approve</span>
                    </button>
                    <button
                        onClick={handleStake}
                        disabled={!isApprove || Number(amount) > Number(approveAmount) || amount == 0 || (step.name === 'stake' && step.status === 'pending')}
                        className={styles.rght_btn}
                    >
                        <BtnLoader step={step} target={{ name: 'stake', status: 'pending' }} />
                        <span>Stake</span>
                    </button>
                </div>
            </div>
        </div>
    )
}
